import { h } from 'preact';
import { TextAreaEntry, TextFieldEntry } from '@epx/flow';

export class SfdSectionPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable() {
    // Applies to all elements
    return true;
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;
    const isEdge = !!element.sourceNodeId;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      const event = isEdge ? 'edge:properties-change' : 'node:properties-change';
      lf.emit(event, { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'extraProperties',
        label: i18n.extraProperties || 'Extra Properties',
        entries: [
          {
            id: 'sectionName',
            component: () => (
              <TextFieldEntry
                id="sfd-sectionName"
                label={i18n.sectionName || 'Section Name'}
                value={props.sectionName || ''}
                onChange={(val) => update('sectionName', val)}
              />
            ),
          },
          {
            id: 'sectionText',
            component: () => (
              <TextAreaEntry
                id="sfd-sectionText"
                label={i18n.sectionText || 'Text'}
                value={props.sectionText || ''}
                onChange={(val) => update('sectionText', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
